import React from 'react'
import './styles.scss'
import { useWindowSize } from 'hooks/useWindowSize'

export const DataElementTooltip = ({
  data,
  pos,
  setHovered
}: {
  data:
    | {
        props: { unit: string; prop: string; val: string; color: string }[]
        [key: string]: string | number | any[]
      }
    | undefined
  pos: number[]
  setHovered: React.Dispatch<
    React.SetStateAction<
      | {
          data: {
            name: string
            props: { unit: string; prop: string; val: string; color: string }[]
          }
          pos: [number, number]
        }
      | undefined
    >
  >
}) => {
  let position = pos
  const { width, isMobile } = useWindowSize()
  return (
    <div
      className='DataElementTooltip'
      style={{
        left: position[0],
        top: position[1],
        transform: `translateX(${
          pos[0] > width * 0.7 ? '-100%' : pos[0] < width * 0.3 ? '0%' : '-50%'
        })`
      }}
    >
      {data && (
        <table>
          <thead>
            <tr>
              <td colSpan={2} />
              <td className='country'>
                {data.name}
                <button
                  onClick={() => {
                    setHovered(undefined)
                  }}
                >
                  X
                </button>
              </td>
            </tr>
          </thead>
          <tbody>
            {data.props.map(m => (
              <tr className='prop'>
                <td className='color' width='1%'>
                  <div style={{ backgroundColor: m.color }} />
                </td>
                <td className='val' width='3%'>
                  {(+m.val).toFixed(1)}
                </td>
                <td className='name' width='96%'>
                  <img
                    src={require('images/icons/icons_small_' +
                      m.propid +
                      '.svg')}
                  />{' '}
               <div> {m.prop} <br/><span>{m.unit}</span></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
